<template>
    <eventi-view-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData" :linkPrintData="linkPrintData" :isAllegati="true" :isMateriali="false">
        <template slot="tab-content-event">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-button v-if="jsonData.id !== null && jsonData.id !== undefined" size="sm" variant="outline-info outline-primary-noborder sa-margin-right float-sm-right" @click="onClickReferta" class="mb-2">
                        <i class="far fa-edit"></i>
                        Referta
                    </b-button>
                    <print-component v-if="jsonData.id !== null && !anamnesiFirmata" :jsonData="jsonData" :linkPrintData="linkPrintData" :firmaGrafometrica="true" :codiceApplicativo="codiceApplicativoBotox" :idAnagrafica="idPaziente" nomeCampo="Firma" nomeFile="Anamnesi_Botox_" descrizione="Anamnesi Botox" tipoDocumento="ANAMNESI BOTOX" class="float-sm-right mb-2" @afterSign="onFirmaUpdate"></print-component>
                </b-col>
            </b-row>
            <anamnesi-botox-view-component :jsonData="jsonData" @update="onUpdateJsonData"></anamnesi-botox-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import axios from "axios";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import PrintComponent from "../../../../../utility/components/PrintComponent.vue";
import AnamnesiBotoxViewComponent from "../components/AnamnesiBotoxViewComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    mixins: [UtilityMixin],
    components: { EventiViewComponent, AnamnesiBotoxViewComponent, PrintComponent },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
        },
        // anamnesiFirmata() {
        //     return this.jsonData.firmato === "FIRMATO";
        // },
    },
    mounted() {
        this.jsonData.dataEvento = new Date().getTime();
    },
    data() {
        return {
            linkback: null,
            titoloEvento: "Anamnesi Botox",
            pathResource: "/anamnesibotox",
            pathRestValidation: "/validation",
            linkPrintData: null,
            codiceApplicativoBotox: "BOTOX-ANAMNESI",
            id: "-1",
            isFirmato: false,
            childKey: 0,
            tabIndex: 0,
            showModalLoading: false,
            anamnesiFirmata: false,
            jsonData: {
                dataEvento: new Date().getTime(),
                fonteDati: "",
                fonteDatiAltro: "",
                allergie: "",
                allergieAltro: "",
                fumo: "",
                malattieAutoimmuni: "",
                malattieAutoimmuniNote: "",
                assunzioneFarmaci: "",
                assunzioneFarmaciNote: "",
                interventiChirurgici: "",
                interventiChirurgiciNote: "",
                precedentiTrattamentiMedicinaEstetica: "",
                precedentiTrattamentiMedicinaEsteticaNote: "",
                motivoVisita: "",
                esameObiettivoLocale: "",
                farmaci: "",
            },
        };
    },
    methods: {
        onFirmaUpdate() {
            let me = this;
            me.loadData();
        },
        loadData() {
            let me = this;
            if (me.jsonData.id === null || me.jsonData.id === undefined) {
                return;
            }
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id;
            axios
                .get(link)
                .then((response) => {
                    me.onUpdateJsonData(response.data.data);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        onUpdateFile() {
            let me = this;
            me.childKey++;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.loadDataAllegati(data.id);
            if (me.jsonData.firma) {
                me.btnFirmaVisible = false;
            } else {
                me.btnFirmaVisible = true;
            }
            me.linkPrintData = "/anamnesibotox/print/" + me.jsonData.id;
        },
        onClickReferta() {
            if (!this.anamnesiFirmata) {
                return;
            }
            this.$router.push("/paziente/botox/visita/edit/-1?idPaziente=" + this.idPaziente);
        },
        loadDataAllegati(idRisorsa) {
            let path = "/allegati";
            this.loadDataResources(path, { idRisorsa: idRisorsa }, this.resultAllegatiResponse, null);
        },
        resultAllegatiResponse(response) {
            let listaAllegati = response.data.data;
            this.anamnesiFirmata = listaAllegati.some((allegato) => allegato.statoFirma === "FIRMATO");
        },
    },
};
</script>
